/**
 * Ask AI on the reading page: the book tutor (backend apps/courses/books).
 * Keyed by the template module — `module_id` in the chapter list.
 */

import api from "../../api";

const TUTOR = (moduleId) => `api/books/${moduleId}/tutor`;

export { errorMessage } from "../ContentBank/contentBankApi";

/** { message, request_id, images?, chapter_index?, section?, visible_sections?, highlight_section?, context_text? } */
export const askBook = async (moduleId, body) => (await api.post(`${TUTOR(moduleId)}/chat/`, body)).data;

export const getBookJob = async (moduleId, job) =>
  (await api.get(`${TUTOR(moduleId)}/chat/jobs/${encodeURIComponent(job)}/`)).data;

/** { messages: [{role, content, timestamp, i, context, sources}], has_more, offline?, not_ready? } */
export const getBookHistory = async (moduleId, before = null, limit = 100) =>
  (await api.get(`${TUTOR(moduleId)}/chat/`, { params: { limit, ...(before !== null ? { before } : {}) } })).data;

export const clearBook = async (moduleId) => (await api.delete(`${TUTOR(moduleId)}/chat/`)).data;

/** { online, queued, can_review } */
export const getBookStatus = async (moduleId) => (await api.get(`${TUTOR(moduleId)}/status/`)).data;

/** Mentor: their students on this module and how much each has asked. */
export const getBookStudents = async (moduleId) => (await api.get(`${TUTOR(moduleId)}/students/`)).data.students;

export const getStudentBookHistory = async (moduleId, userId, before = null) =>
  (await api.get(`${TUTOR(moduleId)}/students/${userId}/chat/`, { params: before !== null ? { before } : {} })).data;

// ─── Side conversations: tabs branched from a passage (backend sessions/threads.py) ───

/** The student's tree for this module: [{id, parent, parent_turn, kind, quote, prefix, suffix, title, open, position, exchanges, last_at}] */
export const getBookThreads = async (moduleId) => (await api.get(`${TUTOR(moduleId)}/threads/`)).data.threads;
/** Branch: { parent?, parent_turn?, kind, quote, prefix?, suffix?, around?, chapter_index?, section?, title? } → the thread */
export const createBookThread = async (moduleId, body) => (await api.post(`${TUTOR(moduleId)}/threads/`, body)).data;
export const updateBookThread = async (moduleId, threadId, patch) =>
  (await api.patch(`${TUTOR(moduleId)}/threads/${threadId}/`, patch)).data;
export const askBookThread = async (moduleId, threadId, body) =>
  (await api.post(`${TUTOR(moduleId)}/threads/${threadId}/chat/`, body)).data;
export const getBookThreadHistory = async (moduleId, threadId, before = null, limit = 100) =>
  (await api.get(`${TUTOR(moduleId)}/threads/${threadId}/chat/`, { params: before === null ? { limit } : { before, limit } })).data;
export const getStudentBookThreads = async (moduleId, userId) =>
  (await api.get(`${TUTOR(moduleId)}/students/${userId}/threads/`)).data.threads;
export const getStudentBookThreadHistory = async (moduleId, userId, threadId, before = null) =>
  (await api.get(`${TUTOR(moduleId)}/students/${userId}/threads/${threadId}/chat/`, { params: before === null ? {} : { before } })).data;
